import { Component, OnInit, Input, Output, EventEmitter, ContentChild, TemplateRef, OnDestroy, ElementRef } from '@angular/core';
import {
  IndPhrase,
  CatDocStatusEnum,
  CatPhraseStatusEnum,
  IndElement,
  IndImage,
  CatDocStateTagEnum,
  CatDoc,
  ReferenceDocument,
} from 'src/app/shared/models/cat.model';
import { DataElement, ReferencePhrase } from 'src/app/shared/models/common';
import { CatService } from 'src/app/shared/services/cat.service';
import { NgRedux } from '@redux/redux-compatibility.service';
import { AppState, actionsList } from 'src/app/shared/redux/store';
import { SharedService } from 'src/app/shared/services/shared.service';
import { InputWrapComponent } from 'src/app/shared/components/ui/input-wrap.component';
import { Unsubscribe } from 'redux';
import { ClaimToolElement } from '@shared/models/claim-tool-element.model';
import { ClaimToolElementSaveChangesData } from '@shared/models/claim-tool-element-save-changes-data.model';
import { take, takeUntil } from 'rxjs/operators';
import { CommonService } from '@shared/services/common.service';
import { ParentTileChildrenSelectionResponse } from '@shared/models/parent-tile-children-selection-response.model';
import { Subject } from 'rxjs';
import { ReevalJobService } from '@shared/services/reeval-job.service';
import { ReevalJobTarget } from '@shared/models/reeval-job.model';
import { Config } from 'src/app/config';
import { PropagateActionsFromParentService } from '@shared/services/propagate-actions-from-parent.service';
import { DocumentPositionSyncService } from '@shared/services/document-position-sync.service';

@Component({
    selector: 'cat-doc-phrase-tile',
    templateUrl: './cat-doc-phrase-tile.component.html',
    styleUrls: ['./cat-doc-phrase-tile.component.scss'],
    standalone: false
})
export class CatDocPhraseTileComponent implements OnInit, OnDestroy {
  @Input() stateTag: CatDocStateTagEnum = CatDocStateTagEnum.PRIME;
  @Input() editable: boolean = true;
  @Input() isFilterActive: boolean = false;
  @Input() hasNext: boolean = true;
  @Input() hasPrev: boolean = true;
  @Input() propagateActionFromParent = null;
  @Input() referenceDocuments: ReferenceDocument[] = [];
  @Output() onToggleRequestedPhrase = new EventEmitter();

  isPhrase: boolean = false;
  claimToolLabel: string = 'translate.claim.tool';

  childrenSelectionCancel$ = new Subject();

  selectedRefDoc: ReferenceDocument | null = null;

  @Input('phrase') set data(element: IndElement) {
    this.element = element;
    
    if (this.element instanceof IndPhrase) {
      this.phrase = this.element;
      this.isPhrase = true;
      if (this.phrase.phraseContentType == 'TEXT_CONTENT') {
        
        this.claimToolLabel = 'translate.text.tool';
      }
    } else if (this.element instanceof IndImage) {
      this.indImage = this.element;
      this.isPhrase = false;
    }
  }
  element: IndElement;
  phrase: IndPhrase;
  indImage: IndImage;

  @Input() displayPageNum: boolean;
  @Output() onTogglePhraseView = new EventEmitter();
  @Output() onGoToPhrasePage = new EventEmitter();
  @Output() onUpdateSpellingIssues = new EventEmitter();
  @Output() showNextIndElementEmitter: EventEmitter<boolean> = new EventEmitter();
  @Output() showPrevIndElementEmitter: EventEmitter<boolean> = new EventEmitter();

  phraseStatusOptions: DataElement[] = [];
  phraseDetailsOpenSw: boolean = false;
  phraseEditModeSw: boolean;
  un: Unsubscribe;
  addExtRefOpenSw: boolean;
  showClaimToolDialog: boolean = false;
  claimToolElement: ClaimToolElement;
  claimToolSaveChangesDataInitialValues: ClaimToolElementSaveChangesData;
  destroy$ = new Subject();

  @ContentChild('childTemplate') childTemplate!: TemplateRef<any>;

  @ContentChild('contentTemplate') contentTemplate!: TemplateRef<any>;

  @ContentChild('imageTemplate') imageTemplate!: TemplateRef<any>;
  @ContentChild('footnotesTemplate') footnotesTemplate!: TemplateRef<any>;
  @ContentChild('tablesTemplate') tablesTemplate!: TemplateRef<any>;

  get extSw(): boolean {
    return (
      this.ngRedux.getState().curCat && this.ngRedux.getState().curCat.extSw
    );
  }

  get showMatchSw(): boolean {
    return !this.extSw && this.stateTag != CatDocStateTagEnum.SEC;
  }

  get curCatDoc(): CatDoc {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDoc
      : this.ngRedux.getState().curCatDocStateSec.curCatDoc;
  }

  get curPage(): number {
    return this.stateTag == CatDocStateTagEnum.PRIME
      ? this.ngRedux.getState().curCatDocStatePrime.curCatDocPageNum
      : this.ngRedux.getState().curCatDocStateSec.curCatDocPageNum;
    //return this.ngRedux.getState().curCatDocPageNum;
  }
  set curPage(pageNum) {
    if (this.stateTag == CatDocStateTagEnum.PRIME) {

      this.ngRedux.getState().curCatDocStatePrime.curCatDocPageNum = pageNum;
    } else {
      this.ngRedux.getState().curCatDocStateSec.curCatDocPageNum = pageNum;
    }
  }

  get isShowIssuesOnFullMatchEnabled(): boolean {
    return this.sharedService.isShowIssuesOnFullMatchEnabled();
  }

  get libraryMismatch() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    if (!similarityEvent || similarityEvent == 'POTENTIAL_NEW') {
      return false;
    }
    return this.getFindingEventCategory('TEXT_MISMATCH');
  }

  get referenceIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('REFERENCE_ISSUE');
  }

  get contentPartMismatch() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('MANDATORY_ASSOC_CONTENT_ISSUE');
  }

  get spellingGrammarIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('SPELLING_GRAMMAR_ISSUE');
  }

  get formatMismatch() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('FORMAT_MISMATCH');
  }

  get consistencyIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('CONSISTENCY_ISSUE');
  }

  get fairBalanceIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('FAIR_BALANCE_RISK_ISSUE');
  }

  get complianceIssues() {
    let similarityEvent = this.getSimilarityEvent();
    if (!this.isShowIssuesOnFullMatchEnabled && similarityEvent == 'FULL_MATCH') {
      return false;
    }
    return this.getFindingEventCategory('COMPLIANCE_ISSUE');
  }

  getFindingEventCategory(findingEventCategory: string) {
    let findingEventCategories = [];
    if (this.phrase) {
      findingEventCategories = this.phrase.phraseFindingCategoryDescs;
    }
    let matchFindingEventCategories = findingEventCategories.filter(
      phraseFindingCategoryDesc => findingEventCategory == phraseFindingCategoryDesc[0]
    );
    return matchFindingEventCategories.length > 0 ? matchFindingEventCategories[0] : null;
  }

  getSimilarityEvent() {
    let similarityEvent;
    if (this.phrase) {
      similarityEvent = this.phrase.phraseSimilarityEvent
    } else if (this.indImage) {
      similarityEvent = this.indImage.imageSimilarityEvent;
    }
    return similarityEvent;
  }

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private ngRedux: NgRedux<AppState>,
    private sharedService: SharedService,
    private catService: CatService,
    private commonService: CommonService,
    private propagateActionsFromParentService: PropagateActionsFromParentService,
    private reevalJobService: ReevalJobService,
    private documentPositionSyncService: DocumentPositionSyncService
  ) {
    this.un = this.ngRedux.subscribe(() => {
      const appState = this.ngRedux.getState();
      switch (appState._currentAction) {
        case actionsList.CAT_PHRASE_ANN_CLICKED:
          if (
            (appState._currentActionData as IndElement).elementId ==
              this.element.elementId &&
            ((this.element instanceof IndPhrase &&
              appState._currentActionData instanceof IndPhrase) ||
              (this.element instanceof IndImage &&
                appState._currentActionData instanceof IndImage))
          ) {
            this.openPhraseDetails(null, false);
          }
          break;
      }
    });
  }

  ngOnDestroy(): void {
    if (this.un) this.un();

    this.destroy$.next();
    this.destroy$.complete();
  }

  scrollIntoView(): void {
    const rulesContainer = this.elementRef.nativeElement.closest('.tbl-container') as HTMLElement | null;
    const tile = this.elementRef.nativeElement.querySelector('.tile-container') as HTMLElement | null;
    if (rulesContainer && tile) {
      this.documentPositionSyncService.scrollElementToTop(rulesContainer, tile);
    }
  }

  get reevalTarget(): ReevalJobTarget {
    return {
      kind: 'CAT',
      docId: this.element.docId,
      elementId: this.element.elementId,
      isImage: this.element instanceof IndImage,
      stateTag: this.stateTag
    };
  }

  onReevalRefresh(): void {
    this.reevalJobService.refreshTile(this.reevalTarget).subscribe();
  }

  ngOnInit(): void {
    this.initPhraseStatusOptions();
    // the element is refreshed in place, so ngOnInit does not run again for its new actions
    this.reevalJobService.tileRefreshed$(this.reevalTarget)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.initPhraseStatusOptions());
    
    this.propagateActionFromParent?.pipe(takeUntil(this.destroy$)).subscribe((action: ParentTileChildrenSelectionResponse) => {
      // code executed in child tile
      let selection;
        if (!this.isPhrase) {
          const imageChildrenSelection = action.images.find(image => image.image_id == this.indImage.imageId);
          selection = imageChildrenSelection.action;
        } else {
          const phraseChildrenSelection = action.phrases.find(phrase => phrase.phrase_id == this.phrase.phraseId);
          selection = phraseChildrenSelection.action;
        }

        if (this.setIndElementStatus(selection)) {
          
          this.propagateActionsFromParentService.addIndElement(this.element);
        }
        
    })
  }

  private initPhraseStatusOptions() {
    let actions = [];
    if (this.phrase) {
      actions = this.phrase.phraseActions;
    } else if (this.indImage) {
      actions = this.indImage.imageActions;
    }
    // show all actions on old docs
    let isNewRuleDoc = !!this.getSimilarityEvent();
    if (isNewRuleDoc) {
      this.phraseStatusOptions =
      this.sharedService.getCatPhraseUpdStatusOptions().filter(
        s => {
          return actions.indexOf(s.id) >= 0;
        }
      );
    } else {
      this.phraseStatusOptions = this.sharedService.getCatPhraseUpdStatusOptions();
    }

    this.checkIfElementHasSelectedUserStatus(this.element);
  }

  goToPage() {
    this.onGoToPhrasePage.emit();
  }

  openPhraseDetails(event: any, phraseEditModeSw: boolean = false) {
    if (event) event.stopPropagation();
    if (this.element.pageNum != this.curPage) {
        
        this.catService.pdfAnnotationRenderReady$.pipe(take(1)).subscribe(() => {
          // pdf loaded 
          // render bounding box
            this.curPage = this.element.pageNum;
            this.showAnnotation();
      })
      this.catService.changePdfPage$.next(this.element.pageNum);
    } else {

      this.showAnnotation();
    }
    this.ngRedux.dispatch({
      type: actionsList.SELECT_CAT_ELEMENT,
      data: this.element,
    });
    this.phraseEditModeSw = phraseEditModeSw;
    this.phraseDetailsOpenSw = true;
  }
  private setIndElementStatus(selection: string) {

    if (selection != null) {
    
    this.element.isParentActionSelected = true;
    let statusOption = this.phraseStatusOptions.find(statusOption => statusOption.id == selection);
    if (!statusOption) {
      return false;
    }
    
     
      this.element.userStatus = statusOption;
      this.element.statusCode = statusOption.id;
      this.element.statusDescr = this.ngRedux
        .getState()
        .catPhraseStatusList.find(
          (s) => s.id == this.element.userStatus.id
        ).text;

    } else {
        
      this.element.statusCode = null;
      this.element.contextCatPhraseId = null;
      this.element.isParentActionSelected = false;
  }
    return true;
  }
  
  onPhraseStatusChange() {
    
    this.childrenSelectionCancel$.next();
    if (this.element.userStatus == null) {
      this.element.statusCode = null;
      this.element.contextCatPhraseId = null;
      this.element.statusDescr = null;
    } else if (this.element.statusCode == this.element.userStatus.id) {
      this.element.statusCode = CatPhraseStatusEnum.PENDING;
      this.element.contextCatPhraseId = null;
      this.element.userStatus = this.ngRedux
        .getState()
        .catPhraseStatusList.find((s) => s.id == this.element.statusCode);
      this.element.statusDescr = this.ngRedux
        .getState()
        .catPhraseStatusList.find(
          (s) => s.id == this.element.userStatus.id
        ).text;
    } else {
      this.element.statusCode = this.element.userStatus.id;
      this.element.statusDescr = this.ngRedux
        .getState()
        .catPhraseStatusList.find(
          (s) => s.id == this.element.userStatus.id
        ).text;

       if (!this.element.contextCatPhraseId && this.element.catMatches.length > 0) {
        const match = this.element.catMatches[0];
        if (match.catPhrase) {
          this.element.contextCatPhraseId = match.catPhrase.phraseId;
        } else if (match.catImage) {
          this.element.contextCatPhraseId = match.catImage.imageId;
        }
      }
    }
    if (Config.assetConfigData['showChildrenTiles'] && ( Object.keys(this.element.children).length > 0 || this.element.contentChildren.length > 0 || this.element.imageChildren.length > 0)) {
      let actionId = null;

      if (this.element.userStatus != null) {
        actionId = this.element.userStatus.id;
      }
      this.checkIfElementHasSelectedUserStatus(this.element);
      this.commonService.getChildrenSelection(this.curCatDoc.docId, this.element.elementId, actionId, false).pipe(takeUntil(this.childrenSelectionCancel$)).subscribe((selections: ParentTileChildrenSelectionResponse) => {
          
          //EXECUTED IN PARENT TILE

          //this.catService.propagateActionFromParentRule$.next({element: this.element, action: selections});
          this.propagateActionsFromParentService.clear();
          this.propagateActionsFromParentService.addIndElement(this.element);
          this.phrase.propagateActionFromParent.next(selections);
          let elementsToUpdate = this.propagateActionsFromParentService.getIndElementsToUpdate();  
        
        return this.catService.updIndPhraseStatus(this.curCatDoc,
        elementsToUpdate, this.phrase.statusCode, false, 
        null, this.phrase.contextCatPhraseId)
        .pipe(takeUntil(this.childrenSelectionCancel$)).subscribe((data) => {
          elementsToUpdate.forEach((elementToUpdate) => {
            let updPhrase = data.find((d) => d.elementId == elementToUpdate.elementId && d.figureType == elementToUpdate.figureType);
            elementToUpdate.statusCode = updPhrase.statusCode;
            elementToUpdate.statusDescr = updPhrase.statusDescr;
            elementToUpdate.userStatus = updPhrase.userStatus;
            elementToUpdate.viewSw = true;
            this.checkIfElementHasSelectedUserStatus(elementToUpdate);
            this.sharedService.checkConsistencyCheckResultsPanelClose.next();
            this.onToggleRequestedPhrase.emit(elementToUpdate);
            
            
          })

            elementsToUpdate.forEach((p) => {
            p.checkedSw = false;
          });
        },
      (error) => {
          // Handle the error, show message, etc.
          this.sharedService.showInfoMessage({
            messageKey: 'translate.error.propagateActionFromParentRule',
            infoType: 'error'
          });
          this.checkIfElementHasSelectedUserStatus(this.element);
      })

    })

    } else {
    this.checkIfElementHasSelectedUserStatus(this.element);
    this.catService
      .updIndPhraseStatus(
        this.curCatDoc,
        [this.element],
        this.element.statusCode,
        false,
        null,
        this.element.contextCatPhraseId
      )
      .subscribe(
        (data) => {
          this.element.statusCode = data[0].statusCode;
          this.element.statusDescr = data[0].statusDescr;
          this.element.annColor = data[0].annColor
          this.checkIfElementHasSelectedUserStatus(this.element);
          this.sharedService.checkConsistencyCheckResultsPanelClose.next();
          this.onTogglePhraseView.emit();
        },
        (err) => {
          this.checkIfElementHasSelectedUserStatus(this.element);
        }
      );
    }
  }

  togglePhraseView(event: any) {
    this.element.viewSw = !this.element.viewSw;
    this.onTogglePhraseView.emit();
    if (this.element.viewSw) {
      this.catService.focusAnnotationForElement$.next(this.element);
    }
  }

  editPhrase() {
    this.openPhraseDetails(null, true);
  }

  onPhraseDelete() {
    this.phraseDetailsOpenSw = false;
    this.ngRedux.dispatch({
      type: actionsList.DELETE_CAT_DOC_PHRASE,
    });
  }

  onAddExtRef() {
    this.addExtRefOpenSw = true;
  }

  onAddExtRefClose(added: boolean) {
    this.addExtRefOpenSw = false;
    if (added) {
      this.ngRedux.dispatch({
        type: actionsList.RELOAD_CAT_DOC_PAGE_REQ,
        data: false,
      });
    }
  }

  notifySpellingIssuesUpdate() {
    this.onUpdateSpellingIssues.emit();
  }

  showClaimTool(displayClaimToolDialog: boolean = true) {
    //this.warnIfReevalPending();
    // create new component
    if (displayClaimToolDialog) {
      this.showClaimToolDialog = true;
      this.phraseDetailsOpenSw = false;
    } else {
      this.showClaimToolDialog = false;
    }
    
    this.claimToolSaveChangesDataInitialValues = new ClaimToolElementSaveChangesData();
    this.claimToolSaveChangesDataInitialValues.contentType = this.phrase.phraseContentType;
    this.claimToolSaveChangesDataInitialValues.phraseSubTypeCode = this.phrase.subTypeCode;
    this.claimToolSaveChangesDataInitialValues.phraseTypeCode = this.phrase.typeCode;
    this.claimToolElement = this.initializeClaimToolElement();
    
    this.ngRedux.dispatch({
      type: actionsList.GET_CLAIM_TOOL_ELEMENT,
      data: this.claimToolElement
    });
    this.ngRedux.dispatch({
      type: actionsList.GET_CLAIM_TOOL_SAVE_CHANGES_INITIAL_VALUES,
      data: this.claimToolSaveChangesDataInitialValues
    });
    this.ngRedux.dispatch({
      type: actionsList.SELECT_CAT_ELEMENT,
      data: this.element,
    });   

  }

  initializeClaimToolElement() {
    
    let claimToolElement: ClaimToolElement = new ClaimToolElement();
    
    
    //claimToolElement.associatedText = this.phrase.associatedText;
    claimToolElement.contentType = this.phrase.phraseContentType;
    claimToolElement.contentTypeDesc = this.phrase.phraseContentTypeDesc;
    claimToolElement.phraseWords = JSON.parse(JSON.stringify(this.phrase.phraseWords));
    claimToolElement.phraseId = this.phrase.phraseId;
    claimToolElement.isPrecheck = false;
    claimToolElement.docId = this.curCatDoc.docId;
    claimToolElement.runType = 'DOC_IND_REVALUATE';
    claimToolElement.stateTag = this.stateTag;
    claimToolElement.envId = this.ngRedux.getState().curEnv.id;
    claimToolElement.catVersionId = this.ngRedux.getState().curCat.catVersionId;
    claimToolElement.pageNum = this.phrase.pageNum-1;
    claimToolElement.phraseTypeCode = this.phrase.typeCode;
    claimToolElement.phraseSubTypeCode = this.phrase.subTypeCode;
    claimToolElement.phraseTypeCodeDescr = this.phrase.typeDescr;
    claimToolElement.phraseSubTypeCodeDescr = this.phrase.subTypeDescr;

    
    return claimToolElement;
  }

  showNextIndElement(editModeSw: boolean) {
    this.phraseDetailsOpenSw = false;
    this.showNextIndElementEmitter.emit(editModeSw);
  }

  showPrevIndElement(editModeSw: boolean) {
    this.phraseDetailsOpenSw = false;
    this.showPrevIndElementEmitter.emit(editModeSw);
  } 
  showDetailsDialog() {
    this.showClaimToolDialog = false;
    this.openPhraseDetails(null);
  }
  showAnnotation() {
    
    this.catService.showAnnotationForPhrase$.next(this.element);
  }
  hideAnnotation() {
    this.catService.hideAnnotationForPhrase$.next(this.element);
  }

  canViewRefDoc(ref: ReferencePhrase): boolean {
    for (let refDoc of this.referenceDocuments) {
      if (refDoc.mappedReferenceTexts.includes(ref.refCatMatchTxt)) {
        return true;
      }

      for (let consistencyCheckResult of ref.anchors) {
        if (consistencyCheckResult.refDocId == refDoc.docId) {
          return true;
        }
      }
    }
    return false;
  }

  viewRefDoc(ref: ReferencePhrase) {
    for (let refDoc of this.referenceDocuments) {
      if (refDoc.mappedReferenceTexts.includes(ref.refCatMatchTxt)) {
        this.selectedRefDoc = refDoc;
        return;
      }

      for (let consistencyCheckResult of ref.anchors) {
        if (consistencyCheckResult.refDocId == refDoc.docId) {
          this.selectedRefDoc = refDoc;
          return;
        }
      }
    }
  }
  private  checkIfElementHasSelectedUserStatus(element: IndElement) {
          let foundIndex = this.phraseStatusOptions?.findIndex((statusOption) => statusOption.id == element.userStatus?.id);
      if (foundIndex != -1) {

        this.element.disableConsistencyCheckResultsActions = true;
      } else {
        
        this.element.disableConsistencyCheckResultsActions = false;
      }
  }
}
